import Client from 'api/release/HTTPClient';

const campaignSitesAPI = {
  list () {
    return Client.get('/api/campaignSites/', {});
  },
};

export default campaignSitesAPI;
